import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {EntityKeyService} from '@pma-entity/services/entity-key.service';
import {EntityDataLayoutService} from "@layout/layouts/entity-data/entity-data-layout.service";
import {ListPageComponentBase} from "@mojo-mci/list-page-component-base";

@Component({
    selector: 'mojo-tenant-parent-list-page',
    templateUrl: './tenant-parent-list-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TenantParentListPageComponent
  extends ListPageComponentBase
  implements OnInit, OnDestroy {

  constructor(
    private readonly router: Router,
    entityKeyService: EntityKeyService,
    entityDataLayoutService: EntityDataLayoutService) {
    super(entityKeyService, entityDataLayoutService);
  }

  ngOnInit(): void {
    super.ngOnInit('Tenant Parents');
  }

  handleRowSelect(data): void {
    this.router.navigate(['/entity-data/tenant-parent', data['SystemTenantParentRef']]);
  }

  getRowHref = (row) => {
    const tenantParentRef = row['SystemTenantParentRef'];
    return `/entity-data/tenant-parent/${tenantParentRef}`;
  }
}
